// 评论列表目前使用此顺序
export const EMOJI_CONFIGS: Array<{ key: string; uri: string }> = [
    {
        key: '[kissing_heart]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/kissing_heart.png',
    },
    {
        key: '[heart_eyes]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/heart_eyes.png',
    },
    {
        key: '[sweat_smile]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/sweat_smile.png',
    },
    {
        key: '[joy]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/joy.png',
    },
    {
        key: '[sob]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/sob.png',
    },
    {
        key: '[sunglassess]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/sunglassess.png',
    },
    {
        key: '[face_with_steam_from_nose]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/face%20with%20steam%20from%20nose.png',
    },
    {
        key: '[heart]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/heart.png',
    },
    {
        key: '[rose]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/rose.png',
    },
    {
        key: '[pray]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/pray.png',
    },
    {
        key: '[clap]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/clap.png',
    },
    {
        key: '[soccer]',
        uri: 'https://bs3-sgp.corp.kuaishou.com/oversea-kwai-sports/topick/Emoji/soccer.png',
    },
];

export const EMOJI_CONFIGS_MAP = EMOJI_CONFIGS.reduce((pre, cur) => {
    pre[cur.key] = cur.uri;
    return pre;
}, {});

// 动态生成正则表达式
const keys = Object.keys(EMOJI_CONFIGS_MAP)
    .map(key => key.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'))
    .join('|');
export const emojiRegExp = new RegExp(`(${keys})`, 'g');
